import { ClassroomOverviewDTO } from "@/stores/classroomStore_I";
import { ClassroomSourceType } from "@/types/classrooms";

export function isClassroomSynced(classroom: ClassroomOverviewDTO): boolean {
	const sourceType = classroom.sourceType.toLowerCase();
	return sourceType != ClassroomSourceType.Local && sourceType != ClassroomSourceType.CSV && sourceType != ClassroomSourceType.Combined;
}

export function getClassroomDisplayName(classroom: ClassroomOverviewDTO): string {
	// Always prioritise the custom display name if exists
	if (classroom.personalisation?.displayName) {
		return classroom.personalisation.displayName;
	}

	// GROUP types store their name in the description field, except for local groups.
	// CLASSROOM types don't have a description field.
	if (classroom.type === "GROUP" && classroom.description) {
		return classroom.description ?? "";
	} else {
		return classroom.name ?? "";
	}
}
